// global variables
const gift_recipient_name = document.getElementById("gift_recipient_name"),
      gift_recipient_email = document.getElementById("gift_recipient_email"),
      gift_sender_name = document.getElementById("gift_sender_name"),
      gift_sender_message = document.getElementById("gift_sender_message"),
      currentProduct = JSON.parse(document.getElementById("product-info").textContent);
let currentSelectedVariantId = new FormData(document.querySelector(".it-product--form")).get("id");
let isEmailValid = true;

let giftSendMethod = "EMAIL_SEND_METHOD";

// show gifting modal

document.getElementById("giftproduct_btn").addEventListener("click", function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  window.MicroModal.show("gifting-products");
  updateProductVariantInfo();
});
// update product variant info

function updateProductVariantInfo () {
    currentSelectedVariantId = new FormData(document.querySelector(".it-product--form")).get("id");
    const selectedVariantInfo = currentProduct.variants.filter(function(variant) {
        return variant.id == currentSelectedVariantId;
    });


    if ( document.querySelector(".it-product--price .price").hasAttribute("data-product-quantity") ) {
        document.querySelector(".gift-product-box-info--price").innerText = `($${ ( ( selectedVariantInfo[0].price * parseInt(document.querySelector(".it-product--price .price").dataset.productQuantity) ) / 100 ).toFixed(2) })`;
    } else {
        document.querySelector(".gift-product-box-info--price").innerText = `($${ ( selectedVariantInfo[0].price / 100 ).toFixed(2) })`;
    }
    if ( selectedVariantInfo[0].title != "Default Title") {
        document.querySelector(".gift-product-box-info--variant-title").innerText = `${selectedVariantInfo[0].title}`;
    }
}


// gift cart add API Request
function giftCartAddRequest(items) {
  const body = JSON.stringify({
    items
  });

  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    ...{ body },
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      // remove disabled and redirect to cart
      document.getElementById("add_gifting_products").removeAttribute("disabled");
      window.location.href= "/cart";
    })
    .catch(function (error) {
      console.log(error);
    });
}

// gifting tabs

document.querySelectorAll(".gift-information--tab-buttons button").forEach(function(btn) {
  btn.addEventListener("click", function() {
    
    // remove active class from all buttons
    document.querySelectorAll(".gift-information--tab-buttons button").forEach(function(btn) {
      btn.classList.remove("active");
    });
    
    // add active class to current button
    btn.classList.add("active");

    // show selected tab

    const targetId = btn.dataset.id;

    if (targetId == "link") {
      giftSendMethod = "UNIQUE_LINK_SEND_METHOD";
      document.querySelector(".gift-information--tab-content h4").innerText = "Send by Unique Link";
      document.querySelector("#gift_recipient_email_info").innerText = "For membership validation only; we will not email your recipient";
    } else {
      giftSendMethod = "EMAIL_SEND_METHOD";
      document.querySelector(".gift-information--tab-content h4").innerText = "Send by Email";
      document.querySelector("#gift_recipient_email_info").innerText = "";
    }
  });
});

// check valid Email address

gift_recipient_email.addEventListener("input", function (event) {
  var validEmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if(!event.target.value.match(validEmailRegex)) {
    document.querySelector("#gift_recipient_email_info").innerText = "Email is not Valid";
    document.querySelector("#gift_recipient_email_info").style.color = "red";
    isEmailValid = false;
  } else {
    document.querySelector("#gift_recipient_email_info").innerText = "";
    isEmailValid = true;
  }
});

// adding gifting items

document.getElementById("add_gifting_products").addEventListener("click", function() {

  // add disabled
  document.getElementById("add_gifting_products").setAttribute("disabled", "disabled");

  // current form data
  const current_form = new FormData(document.querySelector(".it-product--form"));

  // stop all default action
  event.preventDefault();
  event.stopImmediatePropagation();

  // check if the error message exist and remove
  if(document.getElementById("gift-error-message") !== null) {
    document.getElementById("gift-error-message").remove();
  }

  // check if the required input is blank
  if (gift_recipient_name.value == "" || gift_recipient_email.value == "" || gift_sender_name.value == "") {
    
    // show error message
    const errorHTML = "<div style='width: 100%; color: red;' id='gift-error-message'>Please fill out all the required(*) information</div>";
    document.querySelector(".gift-information").insertAdjacentHTML("beforeend", errorHTML);

    // remove disabled
    document.getElementById("add_gifting_products").removeAttribute("disabled");
    
  } else {
    
    // check if the error message exist and remove
    if(document.getElementById("gift-error-message") !== null) {
      document.getElementById("gift-error-message").remove();
    }

    if (isEmailValid) {
      // build gift product object

      let giftItems = [];
  
      if (document.getElementById("gift-sub-product") !== null) {
  
        // validate the recipient 
  
        grecaptcha.ready(function() {
          grecaptcha.execute('6LfIp-4tAAAAAOgzXUfFeDgfyAcMbviQZp912zWZ', {action: 'shopifyTags'}).then(function(token) {
            fetch("https://www.insidetracker.com/api/public/v1/shopify-tags", {
              method: "POST",
              body: JSON.stringify({
                "email": `${gift_recipient_email.value}`,
               "recaptchaToken": `${token}`,
               "recaptchaAction": "shopifyTags"
              })
            }).then(function(res) {
              return res.json();
            }).then(function(data) {
              if(data.tags.length > 0 && data.tags.includes("hasValidSubscription")) {
                // show error message
                const errorHTML = "<div style='width: 100%; color: red;' id='gift-error-message'>Membership Product Can not gift to Acitve Members</div>";
                document.querySelector(".gift-information").insertAdjacentHTML("beforeend", errorHTML);
            
                // remove disabled
                document.getElementById("add_gifting_products").removeAttribute("disabled");
              } else {
                const subProductInfo = JSON.parse(document.getElementById("gift-sub-product").dataset.info);
                giftItems.push(
                  {
                    id: currentSelectedVariantId,
                    quantity: current_form.get("quantity"),
                    properties: {
                      Country: `${current_form.get("properties[Country]")}`,
                      Province: `${current_form.get("properties[Province]")}`,
                       'Recipient': `${gift_recipient_name.value}`,
                       _givy_recipient_name: `${gift_recipient_name.value}`,
                       _givy_recipient_email: `${gift_recipient_email.value}`,
                       _givy_gifter_name: `${gift_sender_name.value}`, 
                       _givy_send_method: `${giftSendMethod}`, 
                       _givy_message: `${gift_sender_message.value}`
                    }
                  },
                  {
                    id: subProductInfo.id,
                    quantity: 1,
                    properties: { 
                       'Recipient': `${gift_recipient_name.value}`,
                       'Subscription details': "InsideTracker Platform - Delivery every 365 Days X 1",
                       _givy_recipient_name: `${gift_recipient_name.value}`,
                       _givy_recipient_email: `${gift_recipient_email.value}`,
                       _givy_gifter_name: `${gift_sender_name.value}`,
                       _givy_selling_plan_data: subProductInfo.selling_plan_info,
                       _givy_send_method: `${giftSendMethod}`, 
                       _givy_message: `${gift_sender_message.value}`
                    }
                  }
                )
                giftCartAddRequest(giftItems);
              }
            });
          });
        });
        
      } else {
        if (currentProduct.handle == "insidetracker-membership") {
          // validate the recipient 
  
        grecaptcha.ready(function() {
          grecaptcha.execute('6LfIp-4tAAAAAOgzXUfFeDgfyAcMbviQZp912zWZ', {action: 'shopifyTags'}).then(function(token) {
            fetch("https://www.insidetracker.com/api/public/v1/shopify-tags", {
              method: "POST",
              body: JSON.stringify({
                "email": `${gift_recipient_email.value}`,
               "recaptchaToken": `${token}`,
               "recaptchaAction": "shopifyTags"
              })
            }).then(function(res) {
              return res.json();
            }).then(function(data) {
              if(data.tags.length > 0 && data.tags.includes("hasValidSubscription")) {
                // show error message
                const errorHTML = "<div style='width: 100%; color: red;' id='gift-error-message'>Membership Product Can not gift to Acitve Members</div>";
                document.querySelector(".gift-information").insertAdjacentHTML("beforeend", errorHTML);
            
                // remove disabled
                document.getElementById("add_gifting_products").removeAttribute("disabled");
              } else {
                giftItems.push(
                  {
                    id: currentSelectedVariantId,
                    quantity: current_form.get("quantity"),
                    properties: {
                       'Recipient': `${gift_recipient_name.value}`,
                       'Subscription details': "InsideTracker Platform - Delivery every 365 Days X 1",
                       _givy_recipient_name: `${gift_recipient_name.value}`,
                       _givy_recipient_email: `${gift_recipient_email.value}`,
                       _givy_gifter_name: `${gift_sender_name.value}`,
                       _givy_selling_plan_data: `${currentProduct.selling_plan_groups[0].selling_plans[0].id},1,${(currentProduct.price / 100).toFixed(2)}`,
                       _givy_send_method: `${giftSendMethod}`, 
                       _givy_message: `${gift_sender_message.value}`
                    }
                  }
                )
                giftCartAddRequest(giftItems);
                
              }
            });
          });
        });
        } else {
  
          // validate the recipient 
  
          grecaptcha.ready(function() {
            grecaptcha.execute('6LfIp-4tAAAAAOgzXUfFeDgfyAcMbviQZp912zWZ', {action: 'shopifyTags'}).then(function(token) {
              fetch("https://www.insidetracker.com/api/public/v1/shopify-tags", {
                method: "POST",
                body: JSON.stringify({
                  "email": `${gift_recipient_email.value}`,
                 "recaptchaToken": `${token}`,
                 "recaptchaAction": "shopifyTags"
                })
              }).then(function(res) {
                return res.json();
              }).then(function(data) {
                if(data.tags.length > 0 && data.tags.includes("hasValidSubscription") ) {
                  giftItems.push(
                    {
                      id: currentSelectedVariantId,
                      quantity: current_form.get("quantity"),
                      properties: {
                         Country: `${current_form.get("properties[Country]")}`,
                         Province: `${current_form.get("properties[Province]")}`,
                         'Recipient': `${gift_recipient_name.value}`,
                         _givy_recipient_name: `${gift_recipient_name.value}`,
                         _givy_recipient_email: `${gift_recipient_email.value}`,
                         _givy_gifter_name: `${gift_sender_name.value}`, 
                         _givy_send_method: `${giftSendMethod}`, 
                         _givy_message: `${gift_sender_message.value}`
                      }
                    }
                  )
  
                  giftCartAddRequest(giftItems);
                } else {
                  // show error message
                  const errorHTML = "<div style='width: 100%; color: red;' id='gift-error-message'>Exclusive Products can only gift to Active Members</div>";
                  document.querySelector(".gift-information").insertAdjacentHTML("beforeend", errorHTML);
              
                  // remove disabled
                  document.getElementById("add_gifting_products").removeAttribute("disabled");
                }
              });
            });
          });
          
        }
        
      }
    }
    else {
      // show error message
      const errorHTML = "<div style='width: 100%; color: red;' id='gift-error-message'>Please provide a valid Email Address</div>";
      document.querySelector(".gift-information").insertAdjacentHTML("beforeend", errorHTML);
  
      // remove disabled
      document.getElementById("add_gifting_products").removeAttribute("disabled");
    }
  }
});

